export default __webpack_public_path__ + "static/night_ctaModule_table_mobile-13d44870497f6e9fa122f5634fc1aa3d.webp";